import { defineComponent, ref, computed, onBeforeUnmount } from "vue";
import focusableSelectors from "./component-library282.mjs";
import { getConfig } from "./component-library2.mjs";
import slugify from "./component-library76.mjs";
import Heading from "./component-library6.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "base-dialog",
  props: {
    customClass: {
      type: [String, Object],
      default: null
    },
    customContainerClass: {
      type: [String, Object],
      default: null
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    dataTealiumRel: {
      type: String,
      default: ""
    },
    headingText: {
      type: String,
      default: void 0
    },
    closeOnBackdrop: { type: Boolean },
    closeAutofocus: { type: Boolean },
    isModal: { type: Boolean },
    disableFocusTrap: { type: Boolean }
  },
  setup(__props, { expose }) {
    const props = __props;
    const dialog = ref(null);
    const isDialogOpen = ref(false);
    const timeout = ref(null);
    const { tealium } = getConfig();
    const tealiumName = computed(() => props.isModal ? "modal" : "flyout");
    const maintainTabFocus = (event) => {
      if (event.key !== "Tab" || !dialog.value)
        return;
      const focusableElements = dialog.value.querySelectorAll(focusableSelectors.join(", "));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (event.target === lastElement && !event.shiftKey) {
        event.preventDefault();
        firstElement.focus();
      }
      if (event.target === firstElement && event.shiftKey) {
        event.preventDefault();
        lastElement.focus();
      }
    };
    function openDialog() {
      isDialogOpen.value = true;
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      timeout.value = setTimeout(() => {
        var _a, _b, _c, _d;
        if (props.isModal) {
          (_a = dialog.value) == null ? void 0 : _a.showModal();
        } else {
          (_b = dialog.value) == null ? void 0 : _b.show();
        }
        if (!props.disableFocusTrap) {
          document.body.addEventListener("keydown", maintainTabFocus, true);
        }
        if (tealium) {
          const rel = props.dataTealiumRel || ((_d = (_c = dialog.value) == null ? void 0 : _c.querySelector(".base-dialog__header")) == null ? void 0 : _d.innerText);
          tealium.link({ wt_link_id: `content.${tealiumName.value}.${slugify(rel)}.open` });
        }
      }, 1);
    }
    function closeNative() {
      var _a, _b;
      document.body.removeEventListener("keydown", maintainTabFocus, true);
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      if (tealium) {
        const rel = props.dataTealiumRel || ((_b = (_a = dialog.value) == null ? void 0 : _a.querySelector(".base-dialog__header")) == null ? void 0 : _b.innerText);
        tealium.link({ wt_link_id: `content.${tealiumName.value}.${slugify(rel)}.close` });
      }
      timeout.value = setTimeout(() => {
        isDialogOpen.value = false;
      }, 126);
    }
    function closeDialog() {
      var _a;
      (_a = dialog.value) == null ? void 0 : _a.close();
    }
    function handleBackdropClick() {
      if (props.closeOnBackdrop) {
        closeDialog();
      }
    }
    onBeforeUnmount(() => {
      document.body.removeEventListener("keydown", maintainTabFocus, true);
    });
    expose({ openDialog, closeDialog });
    return { __sfc: true, props, dialog, isDialogOpen, timeout, tealium, tealiumName, maintainTabFocus, openDialog, closeNative, closeDialog, handleBackdropClick, Heading, LinkButton };
  }
});
export {
  _sfc_main as default
};
